import Vue from 'vue';
import Vuex from 'vuex';

import AppModule from '@/store/modules/app';
import UserModule from '@/store/modules/user';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    app: AppModule,
    user: UserModule,
  },
});
